/*
 * faq-filter.js -- hledání a filtr publika na výpisu Nápovědy
 * (plán 16-01, komponenty `faq-catnav.php` a `faq-panel.php`).
 *
 * PORT Z NÁVRHU SE DVĚMA ZÁMĚRNÝMI ODCHYLKAMI.
 *
 * 1. DIAKRITIKA. Návrh (`navrh-th-faq.html` ř. 1397-1421) porovnává dotaz
 *    a `data-t` prostým `toLowerCase()`. Na češtině to znamená, že „napoveda"
 *    nenajde „nápovědu" a „prihlaseni" nenajde „přihlášení" -- přesně případ,
 *    který kontrakt mobilní vrstvy jmenuje. Obě strany porovnání proto
 *    procházejí `normalize('NFD')` a odstraněním diakritických znamének, takže
 *    hledání funguje s háčky i bez nich.
 *
 * 2. PUBLIKUM SE FILTRUJE PER ŘÁDEK, NE PER PANEL. Návrh skryje celou
 *    kategorii podle jedné hodnoty `data-aud` na panelu. Reálná data jsou
 *    jemnější: článek „Focení a uložení fotek" leží v kategorii označené
 *    „hráči", ale v databázi má Hráče I Organizátory. Filtr proto čte skutečné
 *    slugy řádku (`data-aud` na `.fqrow`) a porovnává je se slugy, které nese
 *    tlačítko (`data-slugs`) -- klíč tlačítka z návrhu (`org`) totiž není slug
 *    termu v datech (`organizatori`, anglicky `organizators`).
 *
 * DVĚ INSTANCE VYHLEDÁVACÍHO POLE JSOU ZÁMĚR. Navigace se vykresluje dvakrát
 * (sloupec pro desktop, lišta pro mobil), takže `#fqq` i `#audsel` jsou v DOM
 * dvakrát a modul je hledá přes `querySelectorAll`. `getElementById` by viděl
 * jen první z nich a mobilní pole by nefiltrovalo vůbec.
 *
 * BEZ JS STRÁNKA FUNGUJE. Seznam článků je serverem vykreslený a prolinkovaný;
 * filtr je vylepšení, ne nosič obsahu. Modul proto nic nevytváří ani nemaže --
 * pracuje výhradně s `classList`, `style.display`, `value` a `aria-disabled`.
 * Modul do stránky nevkládá žádné HTML ani žádnou adresu -- ani jeden ze
 * zápisových bodů, které by šlo zneužít (bod n plánu: nula sinků).
 */

const HIDE_CLASS = 'hide';
const ACTIVE_CLASS = 'on';

/**
 * Text bez diakritiky a malými písmeny.
 *
 * @param {string} value Vstup.
 * @returns {string} Porovnatelný tvar.
 */
export function normalizeSearchText(value) {
	return String(value || '')
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.toLowerCase()
		.trim();
}

/**
 * Spustí hledání a filtr publika nad výpisem Nápovědy.
 *
 * @returns {void}
 */
export function init() {
	const inputs = [].slice.call(document.querySelectorAll('#fqq, .js-fqq'));
	const panels = [].slice.call(document.querySelectorAll('.catpanel'));
	const buttons = [].slice.call(document.querySelectorAll('.audsel button'));
	const chips = [].slice.call(document.querySelectorAll('.catnav a'));
	const nores = document.querySelector('#fqnores');

	if (!panels.length) {
		return;
	}

	let activeSlugs = [];

	function rowMatchesAudience(row) {
		if (!activeSlugs.length) {
			return true;
		}

		const rowSlugs = String(row.getAttribute('data-aud') || '').split(' ');

		for (let i = 0; i < activeSlugs.length; i++) {
			if (rowSlugs.indexOf(activeSlugs[i]) > -1) {
				return true;
			}
		}

		return false;
	}

	function apply() {
		const query = normalizeSearchText(inputs.length ? inputs[0].value : '');
		let seen = 0;
		const visibleBySlug = {};

		panels.forEach(function (panel) {
			let visibleInPanel = 0;

			[].slice.call(panel.querySelectorAll('.fqrow')).forEach(function (row) {
				const haystack = normalizeSearchText(row.getAttribute('data-t'));
				const hitQuery = !query || haystack.indexOf(query) > -1;
				const show = hitQuery && rowMatchesAudience(row);

				row.classList.toggle(HIDE_CLASS, !show);

				if (show) {
					visibleInPanel++;
					seen++;
				}
			});

			panel.classList.toggle(HIDE_CLASS, visibleInPanel === 0);
			visibleBySlug[panel.id] = visibleInPanel;
		});

		// Chip kategorie, která po filtru nemá jediný viditelný článek, by mířil
		// na skrytou kotvu -- proto se vypne, ne skryje (pořadí lišty zůstává).
		chips.forEach(function (chip) {
			const target = String(chip.getAttribute('href') || '').replace('#', '');

			if (!Object.prototype.hasOwnProperty.call(visibleBySlug, target)) {
				return;
			}

			if (visibleBySlug[target] === 0) {
				chip.setAttribute('aria-disabled', 'true');
			} else {
				chip.removeAttribute('aria-disabled');
			}
		});

		if (nores) {
			nores.style.display = seen ? 'none' : 'block';
		}
	}

	inputs.forEach(function (input) {
		input.addEventListener('input', function (event) {
			inputs.forEach(function (other) {
				if (other !== event.target) {
					other.value = event.target.value;
				}
			});

			apply();
		});
	});

	buttons.forEach(function (button) {
		button.addEventListener('click', function () {
			const key = button.getAttribute('data-a') || '';
			const slugs = String(button.getAttribute('data-slugs') || '').split(' ');

			activeSlugs = slugs.filter(function (slug) {
				return slug !== '';
			});

			// Stav se přepíná na VŠECH vykreslených variantách filtru, aby
			// desktopová a mobilní lišta neukazovaly každá něco jiného.
			buttons.forEach(function (other) {
				other.classList.toggle(ACTIVE_CLASS, (other.getAttribute('data-a') || '') === key);
			});

			apply();
		});
	});

	apply();
}
